export const securityKeys = Object.freeze({
    DASHBOARD: "Dashboard",
    SKILL_CONFIGURATION: "Skill Configuration",
    SKILL_CATEGORIES: "Skill Categories",
    ADD_SKILL_CATEGORIES: "Add Skill Categories",
    UPDATE_SKILL_CATEGORIES: "Update Skill Categories",
    DELETE_SKILL_CATEGORIES: "Delete Skill Categories",
    LIST_SKILL_CATEGORIES: "List Skill Categories",
    SKILL_MANAGEMENT: "Skill Management",
    ADD_SKILL_MANAGEMENT: "Add Skill Management",
    UPDATE_SKILL_MANAGEMENT: "Update Skill Management",
    DELETE_SKILL_MANAGEMENT: "Delete Skill Management",
    LIST_SKILL_MANAGEMENT: "List Skill Management",
    HUMAN_RESOURCE: "Human Resource",
    APPLICANT: "Applicant",
    ADD_APPLICANT: "Add Applicant",
    UPDATE_APPLICANT: "Update Applicant",
    DELETE_APPLICANT: "Delete Applicant",
    RESTORE_APPLICANT: "Restore Applicant",
    LIST_APPLICANT: "List Applicant",
    APPLICANT_INTERACTION: "Applicant Interaction",
    ADD_APPLICANT_INTERACTION: "Add Applicant Interaction",
    UPDATE_APPLICANT_INTERACTION: "Update Applicant Interaction",
    DELETE_APPLICANT_INTERACTION: "Delete Applicant Interaction",
    LIST_APPLICANT_INTERACTION: "List Applicant Interaction",
    ORGANIZATION: "Organization",
    MANAGE_ORGANIZATION: "Manage Organization",
    ADD_MANAGE_ORGANIZATION: "Add Manage Organization",
    UPDATE_MANAGE_ORGANIZATION: "Update Manage Organization",
    LIST_MANAGE_ORGANIZATION: "List Manage Organization",
    DELETE_MANAGE_ORGANIZATION: "Delete Manage Organization",
    ORGANIZATION_BRANDING: "Organization Branding",
    ORGANIZATION_EMAIL_CONFIGURATION: "Organization Email Configuration",
    SYSTEM_CONFIGURATION: "System Configuration",
    INTERVIEW_ROUND: "Interview Round",
    ADD_INTERVIEW_ROUND: "Add Interview Round",
    UPDATE_INTERVIEW_ROUND: "Update Interview Round",
    LIST_INTERVIEW_ROUND: "List Interview Round",
    DELETE_INTERVIEW_ROUND: "Delete Interview Round",
    INTERVIEW_TYPE: "Interview Type",
    ADD_INTERVIEW_TYPE: "Add Interview Type",
    UPDATE_INTERVIEW_TYPE: "Update Interview Type",
    LIST_INTERVIEW_TYPE: "List Interview Type",
    DELETE_INTERVIEW_TYPE: "Delete Interview Type",
    JOB_OPENINGS: "Job Openings",
    ADD_JOB_OPENINGS: "Add Job Openings",
    UPDATE_JOB_OPENINGS: "Update Job Openings",
    LIST_JOB_OPENINGS: "List Job Openings",
    DELETE_JOB_OPENINGS: "Delete Job Openings",
    REJECTED_REASON: "Rejected Reason",
    ADD_REJECTED_REASON: "Add Rejected Reason",
    UPDATE_REJECTED_REASON: "Update Rejected Reason",
    LIST_REJECTED_REASON: "List Rejected Reason",
    DELETE_REJECTED_REASON: "Delete Rejected Reason",
    FOLLOWUP_REASON: "Follow-up Reason",
    ADD_FOLLOWUP_REASON: "Add Follow - up Reason",
    UPDATE_FOLLOWUP_REASON: "Update Follow - up Reason",
    LIST_FOLLOWUP_REASON: "List Follow - up Reason",
    DELETE_FOLLOWUP_REASON: "Delete Follow - up Reason",
    MANAGEMENT: "Management",
    MANAGE_USERS: "Manage Users",
    ADD_USERS: "Add Users",
    UPDATE_USERS: "Update Users",
    LIST_USERS: "List Users",
    DELETE_USERS: "Delete Users",
    MANAGE_ROLES: "Manage Roles",
    ADD_ROLES: "Add Roles",
    UPDATE_ROLES: "Update Roles",
    LIST_ROLES: "List Roles",
    DELETE_ROLES: "Delete Roles",
    MANAGE_EMAIL_TEMPLATE: "Manage Email Template",
    MANAGE_NOTIFICATIONS: "Manage Notifications",
    ADD_EMAIL_TEMPLATE: "Add Email Template",
    UPDATE_EMAIL_TEMPLATE: "Update Email Template",
    LIST_EMAIL_TEMPLATE: "List Email Template",
    DELETE_EMAIL_TEMPLATE: "Delete Email Template",
    MANAGE_APPLICANT_STATUS: "Manage Applicant Status",
    ADD_APPLICANT_STATUS: "Add Applicant Status",
    UPDATE_APPLICANT_STATUS: "Update Applicant Status",
    LIST_APPLICANT_STATUS: "List Applicant Status",
    DELETE_APPLICANT_STATUS: "Delete Applicant Status",
    MANAGE_CHANNEL: "Manage Channel",
    ADD_MANAGE_CHANNEL: "Add Manage Channel",
    UPDATE_MANAGE_CHANNEL: "Update Manage Channel",
    LIST_MANAGE_CHANNEL: "List Manage Channel",
    DELETE_MANAGE_CHANNEL: "Delete Manage Channel",
    MANAGE_SOURCE: "Manage Source",
    ADD_SOURCE: "Add Source",
    UPDATE_SOURCE: "Update Source",
    LIST_SOURCE: "List Source",
    DELETE_SOURCE: "Delete Source",
    MANAGE_DEPARTMENTS: "Manage Departments",
    ADD_DEPARTMENTS: "Add Departments",
    UPDATE_DEPARTMENTS: "Update Departments",
    LIST_DEPARTMENTS: "List Departments",
    DELETE_DEPARTMENTS: "Delete Departments",
    SECURITY: "Security",
    VIEW_PERMISSIONS: "View Permissions",
    EDIT_PERMISSION: "Edit Permission",
    REPORTS: "Reports",
    JOB_REQUISITION: "Job Requisition",
    ADD_JOB_REQUISITION: "Add Job Requisition",
    UPDATE_JOB_REQUISITION: "Update Job Requisition",
    LIST_JOB_REQUISITION: "List Job Requisition",
    DELETE_JOB_REQUISITION: "Delete Job Requisition",
    EMPLOYMENT_TYPES: "Employment Types",
    ADD_EMPLOYMENT_TYPES: "Add Employment Types",
    UPDATE_EMPLOYMENT_TYPES: "Update Employment Types",
    LIST_EMPLOYMENT_TYPES: "List Employment Types",
    DELETE_EMPLOYMENT_TYPES: "Delete Employment Types",
    INTERVIEW_WORKFLOW: "Interview Workflow",
    ADD_INTERVIEW_WORKFLOW: "Add Interview Workflow",
    UPDATE_INTERVIEW_WORKFLOW: "Update Interview Workflow",
    LIST_INTERVIEW_WORKFLOW: "List Interview Workflow",
    DELETE_INTERVIEW_WORKFLOW: "Delete Interview Workflow",
    WORKFLOW_STAGES: "Workflow Stages",
    ADD_WORKFLOW_STAGES: "Add Workflow Stages",
    UPDATE_WORKFLOW_STAGES: "Update Workflow Stages",
    LIST_WORKFLOW_STAGES: "List Workflow Stages",
    DELETE_WORKFLOW_STAGES: "Delete Workflow Stages",
    STAGE_SKILL_CONFIGURATION: "Stage Skill Configuration",
    ADD_STAGE_SKILL_CONFIGURATION: "Add Stage Skill Configuration",
    UPDATE_STAGE_SKILL_CONFIGURATION: "Update Stage Skill Configuration",
    LIST_STAGE_SKILL_CONFIGURATION: "List Stage Skill Configuration",
    DELETE_STAGE_SKILL_CONFIGURATION: "Delete Stage Skill Configuration",
    // LIST_CANDIDATE_REPORT: "List Candidate Report",
    // LIST_JOB_REPORT: "List Job Report",
    // LIST_ACTIVITY_LOG: "List Activity Log",
    MANAGE_REPORTS: "Manage Reports",
    LIST_MANAGE_REPORTS: "List Manage Reports",
    APPROVAL_CONFIGURATION: "Approval Configuration",

    
    QUESTION_BANK: "Question Bank",
    ADD_QUESTION_BANK: "Add Question Bank",
    UPDATE_QUESTION_BANK: "Update Question Bank",
    DELETE_QUESTION_BANK: "Delete Question Bank",
    LIST_QUESTION_BANK: "List Question Bank",

    TEST_TEMPLATE: "Test Template",
    ADD_TEST_TEMPLATE: "Add Test Template",
    UPDATE_TEST_TEMPLATE: "Update Test Template",
    DELETE_TEST_TEMPLATE: "Delete Test Template",
    LIST_TEST_TEMPLATE: "List Test Template",

    INTERVIEWER_CALENDAR: "Interviewer Calendar",
    JOB_TEMPLATES: "Job Templates",
    ADD_JOB_TEMPLATES: "Add Job Templates",
    UPDATE_JOB_TEMPLATES: "Update Job Templates",
    DELETE_JOB_TEMPLATES: "Delete Job Templates",
    LIST_JOB_TEMPLATES: "List Job Templates",
    SCHEDULED_INTERVIEWS: "Scheduled Interviews",
    MY_INTERVIEW_CALENDAR: "My Interview Calendar",
    BATCH_RESUME_PROCESS: "Batch Resume Process",
    PARSED_RESUMES: "Parsed Resumes",
    CANDIDATE_REPORT: "Candidate Report",
    JOB_REPORT: "Job Report",
    ACTIVITY_LOG_REPORT: "Activity Log Report",
    SYSTEM_ACTIONS: "System Actions",
    COMPLETED_INTERVIEWS: "Completed Interviews",
    AI_CONTROL_CENTER: "AI Control Center",
    AGENT_OPS: "Agent Ops",
    RECRUITMENT_AI_ASSISTANT: "Recruitment AI Assistant",
    MODULE_ENTITLEMENTS_ADMIN: "Module Entitlements Admin",

    DYNAMIC_FORMS: "Dynamic Forms",
    ADD_DYNAMIC_FORMS: "Add Dynamic Forms",
    UPDATE_DYNAMIC_FORMS: "Update Dynamic Forms",
    DELETE_DYNAMIC_FORMS: "Delete Dynamic Forms",
    LIST_DYNAMIC_FORMS: "List Dynamic Forms",
    PUBLISH_DYNAMIC_FORMS: "Publish Dynamic Forms",
    RETIRE_DYNAMIC_FORMS: "Retire Dynamic Forms",
    ARCHIVE_DYNAMIC_FORMS: "Archive Dynamic Forms",
    CLONE_DYNAMIC_FORMS: "Clone Dynamic Forms",
    TEST_DYNAMIC_FORMS: "Test Dynamic Forms",

    FORM_ASSOCIATIONS: "Form Associations",
    CREATE_FORM_ASSOCIATION: "Create Form Association",
    EDIT_FORM_ASSOCIATION: "Edit Form Association",
    CLONE_FORM_ASSOCIATION: "Clone Form Association",
    ACTIVE_FORM_ASSOCIATION: "Active Form Association",
    DEACTIVE_FORM_ASSOCIATION: "DeActive Form Association",
    ARCHIVE_FORM_ASSOCIATION: "Archive Form Association",

    // Legacy aliases retained so older references keep working.
    FORM_ASSIGNMENTS: "Form Associations",
    ASSIGN_FORMS: "Create Form Association",
    VIEW_FORM_ASSIGNMENTS: "Form Associations",
    CANCEL_FORM_ASSIGNMENTS: "DeActive Form Association",
    REOPEN_FORM_ASSIGNMENTS: "Active Form Association",
    EXTEND_FORM_ASSIGNMENTS: "Archive Form Association",
});

export const securityKeyIds = Object.freeze({
    DASHBOARD: 1,
    SKILL_CONFIGURATION: 2,
    SKILL_CATEGORIES: 3,
    ADD_SKILL_CATEGORIES: 4,
    UPDATE_SKILL_CATEGORIES: 5,
    DELETE_SKILL_CATEGORIES: 6,
    LIST_SKILL_CATEGORIES: 7,
    SKILL_MANAGEMENT: 8,
    ADD_SKILL_MANAGEMENT: 9,
    UPDATE_SKILL_MANAGEMENT: 10,
    DELETE_SKILL_MANAGEMENT: 11,
    LIST_SKILL_MANAGEMENT: 12,
    HUMAN_RESOURCE: 13,
    APPLICANT: 14,
    ADD_APPLICANT: 15,
    UPDATE_APPLICANT: 16,
    DELETE_APPLICANT: 17,
    RESTORE_APPLICANT: 18,
    LIST_APPLICANT: 19,
    APPLICANT_INTERACTION: 20,
    ADD_APPLICANT_INTERACTION: 21,
    UPDATE_APPLICANT_INTERACTION: 22,
    DELETE_APPLICANT_INTERACTION: 23,
    LIST_APPLICANT_INTERACTION: 24,
    ORGANIZATION: 25,
    MANAGE_ORGANIZATION: 26,
    ADD_MANAGE_ORGANIZATION: 27,
    UPDATE_MANAGE_ORGANIZATION: 28,
    LIST_MANAGE_ORGANIZATION: 29,
    DELETE_MANAGE_ORGANIZATION: 30,
    ORGANIZATION_BRANDING: 31,
    ORGANIZATION_EMAIL_CONFIGURATION: 32,
    SYSTEM_CONFIGURATION: 33,
    INTERVIEW_ROUND: 34,
    ADD_INTERVIEW_ROUND: 35,
    UPDATE_INTERVIEW_ROUND: 36,
    LIST_INTERVIEW_ROUND: 37,
    DELETE_INTERVIEW_ROUND: 38,
    INTERVIEW_TYPE: 39,
    ADD_INTERVIEW_TYPE: 40,
    UPDATE_INTERVIEW_TYPE: 41,
    LIST_INTERVIEW_TYPE: 42,
    DELETE_INTERVIEW_TYPE: 43,
    JOB_OPENINGS: 44,
    ADD_JOB_OPENINGS: 45,
    UPDATE_JOB_OPENINGS: 46,
    LIST_JOB_OPENINGS: 47,
    DELETE_JOB_OPENINGS: 48,
    REJECTED_REASON: 49,
    ADD_REJECTED_REASON: 50,
    UPDATE_REJECTED_REASON: 51,
    LIST_REJECTED_REASON: 52,
    DELETE_REJECTED_REASON: 53,
    FOLLOWUP_REASON: 54,
    ADD_FOLLOWUP_REASON: 55,
    UPDATE_FOLLOWUP_REASON: 56,
    LIST_FOLLOWUP_REASON: 57,
    DELETE_FOLLOWUP_REASON: 58,
    MANAGEMENT: 59,
    MANAGE_USERS: 60,
    ADD_USERS: 61,
    UPDATE_USERS: 62,
    LIST_USERS: 63,
    DELETE_USERS: 64,
    MANAGE_ROLES: 65,
    ADD_ROLES: 66,
    UPDATE_ROLES: 67,
    LIST_ROLES: 68,
    DELETE_ROLES: 69,
    MANAGE_EMAIL_TEMPLATE: 70,
    ADD_EMAIL_TEMPLATE: 71,
    UPDATE_EMAIL_TEMPLATE: 72,
    LIST_EMAIL_TEMPLATE: 73,
    DELETE_EMAIL_TEMPLATE: 74,
    MANAGE_APPLICANT_STATUS: 75,
    ADD_APPLICANT_STATUS: 76,
    UPDATE_APPLICANT_STATUS: 77,
    LIST_APPLICANT_STATUS: 78,
    DELETE_APPLICANT_STATUS: 79,
    MANAGE_CHANNEL: 80,
    ADD_MANAGE_CHANNEL: 81,
    UPDATE_MANAGE_CHANNEL: 82,
    LIST_MANAGE_CHANNEL: 83,
    DELETE_MANAGE_CHANNEL: 84,
    MANAGE_SOURCE: 85,
    ADD_SOURCE: 86,
    UPDATE_SOURCE: 87,
    LIST_SOURCE: 88,
    DELETE_SOURCE: 89,
    MANAGE_DEPARTMENTS: 90,
    ADD_DEPARTMENTS: 91,
    UPDATE_DEPARTMENTS: 92,
    LIST_DEPARTMENTS: 93,
    DELETE_DEPARTMENTS: 94,
    SECURITY: 95,
    VIEW_PERMISSIONS: 96,
    EDIT_PERMISSION: 97,
    REPORTS: 98,
    JOB_REQUISITION: 99,
    ADD_JOB_REQUISITION: 100,
    UPDATE_JOB_REQUISITION: 101,
    LIST_JOB_REQUISITION: 102,
    DELETE_JOB_REQUISITION: 103,
    EMPLOYMENT_TYPES: 104,
    ADD_EMPLOYMENT_TYPES: 105,
    UPDATE_EMPLOYMENT_TYPES: 106,
    LIST_EMPLOYMENT_TYPES: 107,
    DELETE_EMPLOYMENT_TYPES: 108,
    INTERVIEW_WORKFLOW: 109,
    ADD_INTERVIEW_WORKFLOW: 110,
    UPDATE_INTERVIEW_WORKFLOW: 111,
    LIST_INTERVIEW_WORKFLOW: 112,
    DELETE_INTERVIEW_WORKFLOW: 113,
    WORKFLOW_STAGES: 114,
    ADD_WORKFLOW_STAGES: 115,
    UPDATE_WORKFLOW_STAGES: 116,
    LIST_WORKFLOW_STAGES: 117,
    DELETE_WORKFLOW_STAGES: 118,
    MANAGE_SKILLS: 119,
    ADD_MANAGE_SKILLS: 120,
    UPDATE_MANAGE_SKILLS: 121,
    LIST_MANAGE_SKILLS: 122,
    DELETE_MANAGE_SKILLS: 123,
    // LIST_CANDIDATE_REPORT: 124,
    // LIST_JOB_REPORT: 125,
    // LIST_ACTIVITY_LOG: 126,
    MANAGE_REPORTS: 127,
    LIST_MANAGE_REPORTS: 128,
    APPROVAL_CONFIGURATION: 129,

    QUESTION_BANK: 130,
    ADD_QUESTION_BANK: 131,
    UPDATE_QUESTION_BANK: 132,
    DELETE_QUESTION_BANK: 133,
    LIST_QUESTION_BANK: 134,

    TEST_TEMPLATE: 141,
    ADD_TEST_TEMPLATE: 142,
    UPDATE_TEST_TEMPLATE: 143,
    DELETE_TEST_TEMPLATE: 144,
    LIST_TEST_TEMPLATE: 145,
    
    INTERVIEWER_CALENDAR: 135,
    JOB_TEMPLATES: 136,
    ADD_JOB_TEMPLATES: 137,
    UPDATE_JOB_TEMPLATES: 138,
    DELETE_JOB_TEMPLATES: 139,
    LIST_JOB_TEMPLATES: 140,
    SCHEDULED_INTERVIEWS: 146,
    MY_INTERVIEW_CALENDAR: 147,
    BATCH_RESUME_PROCESS: 148,
    PARSED_RESUMES: 149,
    CANDIDATE_REPORT: 150,
    JOB_REPORT: 151,
    ACTIVITY_LOG_REPORT: 152,
    SYSTEM_ACTIONS: 153,
    AI_CONTROL_CENTER: 154,
    COMPLETED_INTERVIEWS: 155,
    MANAGE_NOTIFICATIONS:156,
    RECRUITMENT_AI_ASSISTANT: 157,
    AGENT_OPS: 158,
    MODULE_ENTITLEMENTS_ADMIN: 159,

    DYNAMIC_FORMS: 160,
    ADD_DYNAMIC_FORMS: 161,
    UPDATE_DYNAMIC_FORMS: 162,
    DELETE_DYNAMIC_FORMS: 163,
    LIST_DYNAMIC_FORMS: 164,
    PUBLISH_DYNAMIC_FORMS: 165,
    RETIRE_DYNAMIC_FORMS: 166,
    ARCHIVE_DYNAMIC_FORMS: 167,
    CLONE_DYNAMIC_FORMS: 168,
    TEST_DYNAMIC_FORMS: 169,

    FORM_ASSOCIATIONS: 170,
    EDIT_FORM_ASSOCIATION: 171,
    CLONE_FORM_ASSOCIATION: 172,
    ACTIVE_FORM_ASSOCIATION: 173,
    DEACTIVE_FORM_ASSOCIATION: 174,
    ARCHIVE_FORM_ASSOCIATION: 175,
    CREATE_FORM_ASSOCIATION: 176,

    // Legacy aliases retained so older references keep working.
    FORM_ASSIGNMENTS: 170,
    ASSIGN_FORMS: 176,
    VIEW_FORM_ASSIGNMENTS: 170,
    CANCEL_FORM_ASSIGNMENTS: 174,
    REOPEN_FORM_ASSIGNMENTS: 173,
    EXTEND_FORM_ASSIGNMENTS: 175,
});
